'use strict'

// Module qui gère les tooltips bootstrap

/*
 * Fonction qui init le validator bootstrap sur des input.
 * Le premier paramètre représente la class de l'input sur lequel il faut init le validator
 */
function initForm(classOfElementToInit, callback, callBackOnField) {
    $(classOfElementToInit)
        .bootstrapValidator({
            fields: {
                'model.CP': {
                    validators: {
                        callback: {
                            message:
                                'Veuillez vérifier le code postal et la ville',
                            callback: function (value, validator, $field) {
                                return $field.data('villecperror') == 0
                            }
                        }
                    }
                },

                'model.Ville': {
                    validators: {
                        callback: {
                            message:
                                'Veuillez vérifier le code postal et la ville',
                            callback: function (value, validator, $field) {
                                return $field.data('villecperror') == 0
                            }
                        }
                    }
                }
            }
        })
        .on('success.form.bv', callback) // sur la validation du form on execute la callback qui doit prendre un form en entrée
        .on('success.field.bv', callBackOnField)
}

function destroyForm(classOfElementToDestroy) {
    $(classOfElementToDestroy).bootstrapValidator('destroy')
}

/*
 * Fonction qui init le validator bootstrap sur des input.
 * Le premier paramètre représente la class de l'input sur lequel il faut init le validator
 */
function initModalForm(classOfModal, classOfElementToInit, callback) {
    $(classOfModal)
        .on('shown.bs.modal', function () {
            $(classOfElementToInit).bootstrapValidator('resetForm', true)
        })
        .on('success.form.bv', callback) // sur la validation du form on execute la callback qui doit prendre un form en entrée
}

/*
 * Va déclarer un champ comme invalide avec le bootstrap validator
 * Premier paramètre : id du formulaire avec le #
 * Deuxieme paramètre : nom du champ
 * Troisième paramètre : nom du validator à utiliser pour invalider le champ
 */
function setItemAsInvalid(formId, fieldName, validator) {
    if (existsField(formId, fieldName)) {
        $(formId).bootstrapValidator(
            'updateStatus',
            fieldName,
            'INVALID',
            validator
        )
    }
}

/*
 * Va déclarer un champ comme invalide avec le bootstrap validator
 * Premier paramètre : id du formulaire avec le #
 * Deuxieme paramètre : nom du champ
 * Troisième paramètre : nom du validator à utiliser pour invalider le champ
 */
function setItemAsValid(formId, fieldName, validator) {
    if (existsField(formId, fieldName)) {
        $(formId).bootstrapValidator(
            'updateStatus',
            fieldName,
            'VALID',
            validator
        )
    }
}

/*
 * Fonction qui désactive une vérification sur un champ du formulaire dont l'id est passé en paramètre
 * Premier paramètre : id du formulaire avec le #
 * Deuxieme paramètre : nom du champ
 * Troisème paramètre : nom du validator à désactiver
 */
function disableValidator(formId, fieldName, validator) {
    if (existsValidators(formId, fieldName, validator)) {
        $(formId).bootstrapValidator(
            'enableFieldValidators',
            fieldName,
            false,
            validator
        )
    }
}

/*
 * Fonction qui active une vérification sur un champ du formulaire dont l'id est passé en paramètre
 * Premier paramètre : id du formulaire avec le #
 * Deuxieme paramètre : nom du champ
 * Troisème paramètre : nom du validator à activer
 */
function enableValidator(formId, fieldName, validator) {
    if (existsValidators(formId, fieldName, validator)) {
        $(formId).bootstrapValidator(
            'enableFieldValidators',
            fieldName,
            true,
            validator
        )
    }
}

function existsValidators(formId, fieldName, validator) {
    const bv = $(formId).data('bootstrapValidator')

    if (bv == null || bv.options == null) {
        return false
    }

    const field = bv.options.fields[fieldName]

    if (field == null) {
        return false
    }

    return field.validators[validator] != null
}

function existsField(formId, fieldName) {
    const bv = $(formId).data('bootstrapValidator')

    if (bv == null || bv.options == null) {
        return false
    }

    const field = bv.options.fields[fieldName]

    return field != null
}

/*
 * Check si l'input est valide ou non. Retourne true si tout les validateurs du field sont passés
 * Premier paramètre : id du formulaire avec le #
 * deuxième paramètre : champ à vérifier si valide ou non
 */
function isValidField(formId, fieldNameOrElement) {
    return $(formId).data('bootstrapValidator').isValidField(fieldNameOrElement)
}

/*
 * Va valider un field passé en paramètre
 * Premier paramètre : id du formulaire avec le #
 * deuxième paramètre : champ à valider
 */
function validateField(formId, fieldNameOrElement) {
    if (existsField(formId, fieldNameOrElement)) {
        $(formId).data('bootstrapValidator').validateField(fieldNameOrElement)
    }
}

function validate(formId, classtoSearch) {
    // Récupération de tous les champs a valider
    $(formId)
        .find(classtoSearch)
        .each(function (index) {
            validateField(formId, $(this).attr('name'))
        })
}

export default {
    initForm: initForm,
    destroyForm: destroyForm,
    initModalForm: initModalForm,
    setItemAsInvalid: setItemAsInvalid,
    setItemAsValid: setItemAsValid,
    disableValidator: disableValidator,
    enableValidator: enableValidator,
    validateField: validateField,
    isValidField: isValidField,
    validate: validate
}
